
export class BankAccountPixRefundCreateModel {
    transferId!: string; 
    originalEndToEndId!: string;
    reason!: PixRefundReasonEnum;
    observation!: string; 
    valueInCents!: number; 
    waitSuccess?: number;

    constructor(init?: Partial<BankAccountPixRefundCreateModel>) {
        Object.assign(this, init);
    }
}

enum PixRefundReasonEnum
{
    BE08 = 1,
    FR01 = 2,
    MD06 = 3,
    SL02 = 4
}